import { render, staticRenderFns } from "./commonFAQ.vue?vue&type=template&id=64e8085d&"
import script from "./commonFAQ.vue?vue&type=script&lang=js&"
export * from "./commonFAQ.vue?vue&type=script&lang=js&"
import style0 from "./commonFAQ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports